import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyAS1aPmFsKBZB52FXPyXUhjIiEudiojm0I",
  authDomain: "thumbbs-au.firebaseapp.com",
  projectId: "thumbbs-au",
  storageBucket: "thumbbs-au.appspot.com",
  messagingSenderId: "657683091078",
  appId: "1:657683091078:web:0e8bf2de00d8399f60cb07",
  measurementId: "G-NGVZGN28LK"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app)
export const auth = getAuth(app)
export const storage = getStorage(app)